module.exports = __webpack_public_path__ + "static/media/logo-external-retina.8af8c3c5.png";